import * as ActionType from './types'

/**
 * set entryPoint and static path
 * @param moduleEntryPoint
 * @param staticAssetPath
 * @param naviType  health || care
 * @returns {{payload: {staticAssetPath: *, moduleEntryPoint: *}, type: string}}
 */
export const setModuleEntryPoint = (
  moduleEntryPoint,
  staticAssetPath,
  naviType
) => ({
  type: ActionType.SET_MODULE_ENTRY_POINT,
  payload: {
    moduleEntryPoint,
    staticAssetPath,
    naviType,
  },
})

/**
 * set Google Maps Cookie
 * @param wantsMaps
 */
export const setWantGoogleMaps = (wantsMaps) => ({
  type: ActionType.SET_WANT_GOOGLE_MAPS,
  payload: wantsMaps,
})

/**
 * reset search state
 * @returns {{type: *}}
 */
export const resetModuleEntryPoint = () => ({
  type: ActionType.RESET_MODULE_ENTRY_ENTRY,
})

/**
 * reset the complete cache state to avoid caching based bugs
 * set client build information
 */
export const resetPreviouslyCacheState = () => ({
  type: ActionType.RESET_PREVIOUSLY_CACHE,
})

export const setClientBuildSpecs = ({ revision, buildTime }) => ({
  type: ActionType.SET_BUILD_SPECS,
  payload: { revision, buildTime },
})
